import React, { useState } from 'react';

function TodoList() {
    const [todos, setTodos] = useState(['Item 1', 'Item 2']);

    const addTodo = todo => setTodos([...todos, todo]);

    return (
        <div>
            {todos.map((todo, index) => <p key={index}>{todo}</p>)}
            <button onClick={() => addTodo('New Item')}>Add Item</button>
        </div>
    );
}

export default TodoList